import { useState } from 'react';
import { QueryParam } from 'services/query-param/query-param';
import { sessionIdService } from 'services/session-id/session-id.service';
import { creatorHostedSessionService } from 'services/localstorage/creator-hosted';

export const CREATOR_HOSTED_PARAM = 'creator_hosted';

const hasCreatorHostedParam = () =>
  QueryParam.getFirst(CREATOR_HOSTED_PARAM) === '1';

// Called once on app load (useAppQueryParams) while the param is in the URL.
export const persistCreatorHostedSession = () => {
  if (!hasCreatorHostedParam()) return;
  creatorHostedSessionService.mark(sessionIdService.get());
};

const readIsCreatorHosted = () =>
  hasCreatorHostedParam() ||
  creatorHostedSessionService.has(sessionIdService.get());

// Creator-hosted sessions keep the creator's departure: the booking UI hides
// date changes. This is a UI-only signal, independent of the API session
// lock (useSessionLockStatus), which keeps its own behaviour.
const useCreatorHostedSession = () => {
  const [isCreatorHosted] = useState(readIsCreatorHosted);
  return { isCreatorHosted };
};

export { useCreatorHostedSession };
